import { render, staticRenderFns } from "./BtnInserirItensRequisicao.vue?vue&type=template&id=4ea44d3e"
import script from "./BtnInserirItensRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnInserirItensRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports